import { ChangeSubscriptionFnReq, ChangeSubscriptionFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

type ChangeSubscriptionResult = ChangeSubscriptionFnRes;

export class ChangeSubscriptionInteractor {
  private readonly changeSubscriptionFn = httpsCallable<
    ChangeSubscriptionFnReq,
    ChangeSubscriptionFnRes
  >(this.functions, 'changeSubscription');

  constructor(private readonly functions: Functions) {}

  public async execute(priceId: string, prorationDate: number): Promise<ChangeSubscriptionResult> {
    const res = await this.changeSubscriptionFn({ priceId, prorationDate });
    return res.data;
  }
}
